<template>
  <div style="display:none">
    <v-select v-model="selectedYears" label="text" :options="option"></v-select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedYears: "Tahun 2021",
      option: [
        { value: "2021", text: "Tahun 2021" },
        { value: "2026", text: "Tahun 2026" },
      ],
    };
  },
};
</script>
